
import { ChangeDetectorRef, Input, OnDestroy, OnInit, ElementRef, Renderer2, Directive } from '@angular/core';
import { WizBaseComponent } from './wiz-base-component';
import { WizTranslationManager } from '../../services/translation/wiz-translation.manager';
import { IWizTranslatable } from '../../interfaces/iwiz-translatable';
import { WizTranslableProperty } from '../../services/translation/wiz-translatable-property.decorator';
import { WizComponentTranslationObj } from '../../obj/translation/wiz-translation.obj';

/** Base class for all translatable wiz' components */
@Directive()
export abstract class WizTranslatableComponent extends WizBaseComponent implements IWizTranslatable, OnInit, OnDestroy {


  /** The components label to be translated */
  @WizTranslableProperty('translatedLabel')
  @Input()
  public set wizLabel(pLabel: string) {
    this._wizLabel = pLabel;
    this.cdref.markForCheck();
  }
  public get wizLabel(): string {
    return this._wizLabel;
  }

  public translatedLabel: string;

  // display or not of the label
  _wizShowLabel: boolean = true;
  @Input()
  public set wizShowLabel(v: boolean) {
    this._wizShowLabel = v;
    this.cdref.markForCheck();
  }
  public get wizShowLabel(): boolean {
    return this._wizShowLabel;
  }

  private _wizTranslationParams: any[];
  @Input()
  public set wizTranslationParams(params: any[]) {
    this._wizTranslationParams = params;
    // sur modification des paramètres, on rafraichit la traduction
    this.wizTranslate(WizTranslationManager.getInstance().getCompTrsVOFor(this));
    this.cdref.markForCheck();
  }
  public get wizTranslationParams(): any[] {
    return this._wizTranslationParams;
  }

  /** Flag to skip register to translation engine */
  _wizSkipTranslation: boolean;
  @Input()
  public set wizSkipTranslation(v: boolean) {
    this._wizSkipTranslation = v;
    this.cdref.markForCheck();
  }
  public get wizSkipTranslation(): boolean {
    return this._wizSkipTranslation;
  }
  /** Constructor
   * @param cdref: ChangeDetectorRef
   * @param elementRef: the dom of the component
   */
  constructor(protected cdref: ChangeDetectorRef, public elementRef: ElementRef, public  renderer: Renderer2) {
    super(cdref, elementRef, renderer);
  }

  /** On init, registration to the translation engine */
  ngOnInit() {
    super.ngOnInit();
    this.wizRegisterTranslation();
  }

  /** On destroy, unregistration from the translation engine */
  ngOnDestroy() {
    super.ngOnDestroy();
    this.wizUnregisterTranslation();
  }

  /** registration to the translation engine */
  wizRegisterTranslation(): void {
    if (!this.wizSkipTranslation) {
      WizTranslationManager.getInstance().componentReference(this);
    }
  }

  /** unregistration from the translation engine */
  wizUnregisterTranslation(): void {
    if (!this.wizSkipTranslation) {
      WizTranslationManager.getInstance().componentUnreference(this);
    }
  }

  /** component translation vo list, to implement */
  getWizComponentTranslationVOs(): WizComponentTranslationObj[] {
    // Error thrown to make sure method implementation is not forgotten
    throw new Error('Method not implemented.');
  }

  /**
   * Translate function called by the translation engine
   * @param compTrsVOList component translations array
   */
  wizTranslate(compTrsVOList: WizComponentTranslationObj[]): void {
    if (compTrsVOList) {
      for (const compTrsVO of compTrsVOList) {
        if (compTrsVO.parentUID === this.entityUID && compTrsVO.translation) {
          if (this.wizTranslationParams && this.wizTranslationParams.length > 0) {
            this[compTrsVO.property] = WizTranslationManager.getInstance().
            translateKey(compTrsVO.translation.key, this.wizTranslationParams);
          } else {
            this[compTrsVO.property] = compTrsVO.translation.value;
          }
        }
      }
    }
    this.cdref.markForCheck();
  }
}
